import { LocationTableItem } from 'components/waste-management/interfaces'

export const getColumns = () => [
  {
    title: 'Nume',
    field: 'name',
    align: 'left',
    type: 'string',
    disableSorting: true
  },
  {
    title: 'Cod METI',
    field: 'metiCode',
    align: 'left',
    type: 'string',
    disableSorting: true
  },
  {
    title: 'Entitate juridica',
    field: 'legalEntity',
    align: 'left',
    type: 'string',
    disableSorting: true,
    collapsible: true
  },
  {
    title: 'Tip',
    field: 'type',
    align: 'left',
    type: 'string',
    disableSorting: true,
    collapsible: true
  },
  {
    title: 'Subtip',
    field: 'subtype',
    align: 'left',
    type: 'string',
    disableSorting: true,
    collapsible: true
  },
  {
    title: 'Categorii',
    field: 'categories',
    align: 'left',
    type: 'string',
    disableSorting: true,
    collapsible: true,
    render: (rowData: LocationTableItem) => <span>{rowData.categories.join(', ')}</span>
  }
]
